"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultComponent = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultComponent = function defaultComponent() {
  return /*#__PURE__*/_react.default.createElement("div", null, "No root component was defined.", /*#__PURE__*/_react.default.createElement("br", null), "Please hook into", ' ', /*#__PURE__*/_react.default.createElement("em", null, /*#__PURE__*/_react.default.createElement("code", null, "REACT_ROOT_COMPONENT")), ".");
};

exports.defaultComponent = defaultComponent;